export default __webpack_public_path__ + "media/logos/primary_light-8961e67d.png";